import React, { Component } from 'react'
import styled from 'styled-components'
import { connect } from 'react-redux';
import _ from 'lodash';

import { Calendar, UpgradeModal } from 'features'

import * as actionCreators from 'store/actions'


const Container = styled.div`
    display: flex;
    flex-direction: column;
    overflow: auto;
`

const Toggle = styled.div`
    opacity: 0;
`

class DayView extends Component {
    constructor(props){
        super(props);
        this.virtuoso = React.createRef();
        const inboxID = this.props.user && this.props.user['inboxID']
        this.state = {
            showNotes: true,
            showTasks: true,
            lastPageID: inboxID
        }

        this.toggleStyle = {
            backgroundColor: 'transparent',
            padding: 0, 
            margin: 0,
            fontSize: '1rem'
        }
        const width = window.innerWidth || this.props.body.clientWidth
        this.defaultStyle = {
            primaryColor: 'var(--primary-color)',
            secondaryColor: 'var(--secondary-color)',
            secondaryColor2: 'var(--primary-accent2-color)',
            padding: this.props.user['full_width'] || width < 1024 ? '1rem var(--main-padding-width-small)' : '1rem var(--main-padding-width)'
        }

    }

    componentDidUpdate() {
        if(this.requestedFrame){
            cancelAnimationFrame(this.requestedFrame);
            this.requestedFrame = null
        }
    }

    scrollHandler = (isScrolling) => {
        (isScrolling & this.props.inputID) && this.props.setInput(null)
    }

    forwardHandler = () => {
        const date = this.props.date.format('MMM D Y')
        const schedule = this.props.data['schedules'] && this.props.data['schedules'][date]

        // schedule && this.props.forwardSchedule(schedule, this.props.data, this.props.uid)
        schedule && this.props.forwardSchedule(this.props.date.format('MMM D Y'), this.props.events, this.props.data, this.props.uid, this.props.sessionId)
    }
    render() {  
        return (
            <Container>
                <Calendar view='day'
                    date={this.props.date}
                    events={this.props.events} 
                    onSchedule={this.props.onSchedule} 
                    step={this.props.user['calendar_step_size']}
                    initialHour={this.props.user['calendar_initial_time']}
                    collectRefs={this.props.collectRefs}
                    disable={this.props.user['subscription_plan'] === 'PERSONAL'}
                    onDisable={() => this.props.setModal(<UpgradeModal trigger='calendar'/>, 'UpgradeModal')}
                    onSelectEvent={this.props.onSelectEvent}
                    // scrollToTime={moment(this.props.date).tz(this.props.user['timezone']).set({hour: 8, minute: 0, second: 0}).toDate()} 
                    // date={moment().set({hour: 8, minute: 0, second: 0}).toDate()}
                    />
            </Container>     
        )
    }
}

const mapStateToProps = state => {
    return {
        uid: state.auth.uid,
        user: state.auth.user,
        data: state.db.present.data && state.db.present.data.toJS(),
        activePageID: state.auth.activePageID,
        sessionId: state.content.sessionId,

        window: state.content.window,
        body: state.content.body,

        showAccess: state.content.showAccess,
        access: state.content.access,
        accessProps: state.content.accessProps,
    }
};

const mapDispatchToProps = dispatch => {
    return {
        setModal: (element, id) => dispatch(actionCreators.setModal(element, id)),
        setAccess: (showAccess, module, accessProps) => dispatch(actionCreators.setAccess(showAccess, module, accessProps)),
        forwardSchedule: (oldDate, events, data, uid, sessionId) => dispatch(actionCreators.forwardSchedule(oldDate, events, data, uid, sessionId)),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(DayView);